export enum DonationStatusTypeEnum {
  DONATED = 'DONATED',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
}
